import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'
import image from '../../assets/images/U1-T1-6a.svg'

const data = {
  question:
    'Vaping and using e-cigarettes carries ______ potential health risks because ________.',
  inputType: 'radio',
  options: [
    {
      label: 'no; you breathe in mostly water vapor',
    },
    {
      label: 'many; they do not contain any nicotine',
    },
    {
      label: 'no; they do not contain any addictive substances',
    },
    {
      label: 'many; you inhale toxic chemicals from the aerosol',
    },
  ],
}

const correctInput = {
  [data.question]: data.options[3].label,
}

const feedback = {
  success: {
    title: 'That’s right!',
    body:
      'When someone vapes or uses e-cigarettes, they inhale an aerosol that contains a variety of chemicals, many of which are harmful.',
  },
  error: {
    title: 'Not quite.',
    body:
      'When someone vapes or uses e-cigarettes, they inhale an aerosol that contains a variety of chemicals, many of which are harmful.',
  },
}

export default {
  title: 'Question 1',
  path: '/prepare/question-1',
  content: (
    <Fragment>
      <Intro title="Question 1" img={image} />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/Question1.js